import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PublicDataViewService {
  private readonly baseUrl = 'apiUrl/omnis/search/public_dataset/';

  constructor(private http: HttpClient) {
  }

  public getData(id: string) {
    return this.http.get(this.baseUrl +  id);
  }
}
